module.exports = __webpack_public_path__ + "static/Candia_The Chocolate Penguin-22afa64c74c413d95b07aeeb6517f3d4.mp4";